import { Matrix } from 'pages/trading/price/promotion/PricePromotionDetailPage';
import { PromotionKpiMatrixColumn } from 'pages/trading/price/promotion/PromotionKpiMatrixColumn';
import { MeasureUnitCode } from 'components/measure-unit/MeasureUnitCode';
import { TitleColumn } from 'pages/trading/price/promotion/TitleColumn';
import { Tile } from 'components/Layout/PageContainer';

export interface PromotionKpiMatrixProperties {
  matrix: Matrix;
}

export function PromotionKpiMatrix({ matrix }: PromotionKpiMatrixProperties) {
  return (
    <Tile className="grid grid-cols-8 w-full col-span-12 mt-4">
      <TitleColumn />
      <PromotionKpiMatrixColumn
        title={'trading.price_change.kpi.avg_price_change'}
        row={matrix.priceChange}
        measureUnitCode={MeasureUnitCode.PERCENT}
        priceColumn
      />
      <PromotionKpiMatrixColumn
        title={'trading.price_change.kpi.items_per_day'}
        row={matrix.itemsPerDay}
        measureUnitCode={MeasureUnitCode.QUANTITY}
      />
      <PromotionKpiMatrixColumn
        title={'trading.price_change.kpi.gmv_per_day'}
        row={matrix.gmvPerDay}
        measureUnitCode={MeasureUnitCode.CURRENCY}
      />
    </Tile>
  );
}
